/**
 * Agentic Payment Transaction History - Shared Constants
 *
 * Centralized configuration values used across transaction history components.
 */

// Pagination Configuration
export const ITEMS_PER_PAGE = 20;
export const WALLETS_PER_PAGE = 50;
export const SEARCH_DEBOUNCE_MS = 300;

// External Services
export const HASHSCAN_BASE_URL = "https://hashscan.io";

// Transaction Categories
export const TRANSACTION_CATEGORIES = {
    ALL: "all",
    DEPOSIT: "Deposit",
    WITHDRAWAL: "Withdrawal",
    INTERNAL_TRANSFER: "Transfer",
    TOKEN_SWAP: "Token Swap",
    AIRDROP: "Airdrop",
    SETTLEMENT: "Settlement",
};

// Transaction Directions
export const TRANSACTION_DIRECTIONS = {
    ALL: "all",
    INCOMING: "incoming",
    OUTGOING: "outgoing",
};

// Transaction Statuses
export const TRANSACTION_STATUSES = {
    ALL: "all",
    SUCCESS: "success",
    PENDING: "pending",
    FAILED: "failed",
};

// View modes
export const VIEWS = {
    WALLETS: "wallets",
    TRANSACTIONS: "transactions",
};

// API Endpoints (admin page_actions)
export const API_ENDPOINTS = {
    HEDERA_WALLETS:
        "/admin/agentic_payment_transaction_history/hedera_wallets",
};
